import { X } from 'lucide-react'

export default function TerminalAISettings({ settings, onChange, onClose, tokenStats }) {
  const update = (key, value) => onChange({ ...settings, [key]: value })

  const totalTokens = (tokenStats?.input || 0) + (tokenStats?.output || 0)

  return (
    <div className="space-y-3 rounded-lg bg-slate-800/60 border border-slate-700/50 p-3">
      {/* Header com título e botão fechar */}
      <div className="flex items-center justify-between">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
          Configurações do Agente
        </p>
        <button
          onClick={onClose}
          title="Fechar configurações"
          className="rounded p-0.5 text-slate-500 hover:bg-slate-700 hover:text-slate-300 transition"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>

      {/* Modo Normal / Pro */}
      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-400 shrink-0">Modo:</span>
        <div className="flex rounded-md border border-slate-600 overflow-hidden text-xs">
          <button
            onClick={() => {
              update('proMode', false)
            }}
            className={`px-3 py-1 transition font-medium ${
              !settings.proMode
                ? 'bg-theme-primary text-white'
                : 'bg-slate-700 text-slate-400 hover:text-slate-200'
            }`}
          >
            Normal
          </button>
          <button
            onClick={() => {
              update('proMode', true)
            }}
            className={`px-3 py-1 transition font-medium ${
              settings.proMode
                ? 'bg-theme-secondary text-white'
                : 'bg-slate-700 text-slate-400 hover:text-slate-200'
            }`}
          >
            Pro ✦
          </button>
        </div>
        {settings.proMode && (
          <span className="text-[10px] text-theme-secondary">Agente autônomo · Opus</span>
        )}
      </div>

      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={settings.autoApproveReads}
          onChange={(e) => update('autoApproveReads', e.target.checked)}
          className="h-4 w-4 rounded border-slate-600 bg-slate-700 text-theme-primary focus:ring-theme-primary focus:ring-offset-0"
        />
        <span className="text-xs text-slate-300">
          Executar comandos de <span className="text-emerald-400 font-medium">leitura</span> automaticamente
        </span>
      </label>

      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={settings.autoApproveWrites}
          onChange={(e) => update('autoApproveWrites', e.target.checked)}
          className="h-4 w-4 rounded border-slate-600 bg-slate-700 text-amber-500 focus:ring-amber-500 focus:ring-offset-0"
        />
        <span className="text-xs text-slate-300">
          Executar comandos de <span className="text-amber-400 font-medium">escrita</span> automaticamente
        </span>
      </label>

      <p className="text-[10px] text-red-400/80">
        Comandos perigosos sempre pedem confirmação, independente das opções acima.
      </p>

      {/* Indicador de contexto/tokens */}
      {totalTokens > 0 && (
        <div className="rounded border border-slate-700/50 bg-slate-900/40 px-2 py-1.5 space-y-0.5">
          <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">
            Contexto da conversa
          </p>
          <div className="flex gap-3 text-[10px] text-slate-400">
            <span>↑ entrada: <span className="text-slate-300 font-mono">{(tokenStats?.input || 0).toLocaleString()}</span></span>
            <span>↓ saída: <span className="text-slate-300 font-mono">{(tokenStats?.output || 0).toLocaleString()}</span></span>
            <span>total: <span className={`font-mono font-semibold ${totalTokens > 50000 ? 'text-red-400' : totalTokens > 20000 ? 'text-amber-400' : 'text-emerald-400'}`}>{totalTokens.toLocaleString()}</span></span>
          </div>
        </div>
      )}
    </div>
  )
}
